//region :: Imports ::
import IAccessTokenProvider from './IAccessTokenProvider';
import {getAuthAccessToken, MNullable} from './Utils';
import {IMsalContext} from '@azure/msal-react';

//endregion

/** */
class AccessTokenProvider implements IAccessTokenProvider {

    private readonly m_msalContext: IMsalContext;
    private readonly m_defaultScopes: MNullable<string[]>;

    /** */
    public constructor(msalContext: IMsalContext, defaultScopes: MNullable<string[]>) {

        this.m_msalContext = msalContext;
        this.m_defaultScopes = defaultScopes;

    }

    /** */
    public async getToken(scopes: string[]): Promise<string> {

        return await getAuthAccessToken(
            this.m_msalContext,
            this.m_defaultScopes === null || this.m_defaultScopes.length === 0 ? scopes : [...this.m_defaultScopes, ...scopes]
        );

    }

}

export default AccessTokenProvider;
